import { render } from "./monthly.vue?vue&type=template&id=00615d4a&scoped=true&ts=true"
import script from "./monthly.vue?vue&type=script&lang=ts"
export * from "./monthly.vue?vue&type=script&lang=ts"

import "./monthly.vue?vue&type=style&index=0&id=00615d4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00615d4a"]])

export default __exports__